module.exports = __webpack_public_path__ + "static/img/dsk-service-bg.28da733.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dsk-service-bg.jpg
// module id = 235
// module chunks = 1